/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PhysicalCheckDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: PhysicalCheckDefinitionDto.source;
    label?: string;
    description?: string;
    defaultNegativeResponse?: string;
}

export namespace PhysicalCheckDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
